import React, { useState } from "react";
import "../../../../../src/style/block.scss";
import "./style.scss";
import "../../../../../src/style/buttons.scss";
import { MdOutlineClear, MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from "react-icons/md";
import { AiOutlineCalendar } from "react-icons/ai";
import ModalComponent from "../../../../features/ModalComponent";
import SortModal from "./sortModal";
import useAdditionalHooks from "../hooks/useAdditionalHooks";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import getId from "../../../../utils/getId";


interface IProps {
  nextWeek: () => void;
  previousWeek: () => void;
  resetSortByExerciseGroup: () => void;
  sortByExerciseGroup: (value: number) => void;
  dateFromState: Date;
  dateToState: Date;
}

const ExerciseBar: React.FC<IProps> = ({
  nextWeek,
  previousWeek,
  dateFromState,
  dateToState,
  sortByExerciseGroup,
  resetSortByExerciseGroup,
}) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const {
    getExerciseGroups,
    exerciseGroups,
    setSelectedExerciseGroupId,
    selectedExerciseGroupId,
    handleResetSelectedExercise,
  } = useAdditionalHooks(sortByExerciseGroup, resetSortByExerciseGroup, dateFromState, dateToState);

  return (
    <React.Fragment>
      <div className="schedule-bar desktop">
        <div className="flex-start-center">
          <button
            onClick={() => {
              setOpen(true);
              getExerciseGroups();
            }}
            className="button medium button-fill-background-main padding-medium"
          >
            {getId(selectedExerciseGroupId) ? `${t("wybrano")} ${selectedExerciseGroupId.name}` : t("wybierz_zajecia")}
          </button>
          {getId(selectedExerciseGroupId) && (
            <button
              onClick={() => {
                handleResetSelectedExercise();
              }}
              className="button medium button-warning"
            >
              <MdOutlineClear className="icon" />
              {t("wyczysc_filtry")}
            </button>
          )}
        </div>







        <div className="flex-start-center">
          <button
            onClick={() => {
              previousWeek();
            }}
            className="button medium button-fill-background-main"
          >
            <MdOutlineKeyboardArrowLeft className="icon" />
          </button>

          <button className="button medium button-fill-background-main padding-medium dates">
            {format(dateFromState, "dd.MM")} <b className="space">-</b>
            {format(dateToState, "dd.MM.yyyy")}
          </button>

          <button className="button medium button-fill-background-main">
            <AiOutlineCalendar className="icon" />
          </button>

          <button
            onClick={() => {
              nextWeek();
            }}
            className="button medium button-fill-background-main"
          >
            <MdOutlineKeyboardArrowRight className="icon" />
          </button>
        </div>
      </div>

      {open && (
        <ModalComponent
          footer={true}
          open={open}
          closeModal={() => setOpen(false)}
          title={t("wybierz_zajecia")}
          onAccept={() => setOpen(false)}
        >
          <SortModal exerciseGroups={exerciseGroups} 
          onSelect={(value) => setSelectedExerciseGroupId(value)} />
        </ModalComponent>
      )}
    </React.Fragment>
  );
};

export default ExerciseBar;
